module.exports = __webpack_public_path__ + "img/D202102_3.9cec5cc8.jpg";